if (!customElements.get('mezuzah-spec-weights')) {
  customElements.define('mezuzah-spec-weights', class extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-mzd-weights]');
      if (!data) return;
      this.weights = JSON.parse(data.textContent);
      this.unsubscribe = window.subscribe?.(window.theme.PUB_SUB_EVENTS.variantChange, event => {
        const id = event?.data?.variant?.id;
        if (!Object.hasOwn(this.weights, String(id))) return;
        this.updateWeight(this.weights[id]);
      });
    }

    updateWeight(grams) {
      const grid = this.querySelector('.mzd__grid--v3');
      for (const template of this.querySelectorAll('[data-mzd-weight-template]')) {
        const key = template.dataset.mzdWeightTemplate;
        let row = Array.from(grid.querySelectorAll('[data-mzd-weight-row]')).find(item => item.dataset.mzdWeightRow === key);
        if (!(Number(grams) > 0)) {
          row?.remove();
          continue;
        }
        if (!row) {
          row = template.content.firstElementChild.cloneNode(true);
          template.after(row);
        }
        const ounces = Number(grams) / 28.349523125;
        const pounds = ounces >= 16;
        const amount = pounds ? Number(grams) / 453.59237 : ounces;
        const unit = pounds ? row.dataset.poundLabel : row.dataset.ounceLabel;
        this.setValue(row.querySelector('dd'), amount.toFixed(1) + (unit ? ' ' + unit : ''));
      }
      const rows = Array.from(grid.querySelectorAll(':scope > [data-mzd-tile]'));
      const tail = rows.length % 4;
      rows.forEach((row, index) => {
        for (const value of [1, 2, 3]) row.classList.toggle('mzd__row--tail-' + value, tail === value && index >= rows.length - tail);
      });
      grid.hidden = rows.length === 0;
    }

    setValue(target, value) {
      if (target.dataset.mzdIsolateHebrew !== 'true') {
        target.textContent = value;
        return;
      }
      const doc = target.ownerDocument;
      const fragment = doc.createDocumentFragment();
      const runs = /[\u0590-\u05ff\uFB1D-\uFB4F]+(?:[ .,:;!?()\[\]{}_\-\/0-9'"]*[\u0590-\u05ff\uFB1D-\uFB4F]+)*/gu;
      let offset = 0;
      for (const match of value.matchAll(runs)) {
        fragment.append(doc.createTextNode(value.slice(offset, match.index)));
        const isolate = doc.createElement('bdi');
        if (target.dataset.mzdHebrewLanguage) isolate.lang = target.dataset.mzdHebrewLanguage;
        if (target.dataset.mzdHebrewDirection && target.dataset.mzdHebrewDirection !== 'inherit') isolate.dir = target.dataset.mzdHebrewDirection;
        isolate.textContent = match[0];
        fragment.append(isolate);
        offset = match.index + match[0].length;
      }
      fragment.append(doc.createTextNode(value.slice(offset)));
      target.replaceChildren(fragment);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }
  });
}
